import { render } from "./WarekiInput.vue?vue&type=template&id=2ef176b0"
import script from "./WarekiInput.vue?vue&type=script&lang=js"
export * from "./WarekiInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__